import { Link } from "react-router-dom";
import "./Banner.css";
function Banner() {
  return (
    <div>
      <section className="bundle_india  pb-4">
        <div className="">
          <div className="row d-flex align-items-center">
            <div className="col-md-6 col-lg-5">
              <div className="banner_img">
                <img
                  src="images/SchoolBundle/India/middle-banner.png"
                  alt="Hello"
                />
                {/* <img
                  src="images/SchoolBundle/India/middle-banner.png"
                  alt="Hello"
                /> */}
              </div>
            </div>
            <div className="col-md-6 col-lg-6 order-1 order-lg-0">
              <h1 className="banner_txt dBlue">
                Middle School
                <br />
                <span className="dPink"> Bundle</span>
              </h1>
              <h2>
                A Unified AI & Robotics Education ecosystem for your school
              </h2>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
export default Banner;
